import React from 'react';
import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import {
	FlyoutMenuItem,
	FlyoutMenuItemTrigger,
	FlyoutMenuItemContent,
	type FlyoutMenuItemTriggerProps,
} from '@atlaskit/navigation-system';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { useEntryPointButtonTrigger } from '@atlassian/jira-entry-point-button-trigger/src/index.tsx';
import { useGetCurrentUrl } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/controller/use-get-current-url/index.tsx';
import { SkeletonNavMenuItems } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/skeleton-nav-menu-items/main.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { MoreProjectsEntrypoint } from '../content/entrypoint.tsx';
import { PACKAGE_NAME, TEAM_NAME } from '../../constants.tsx';

type Props = Omit<FlyoutMenuItemTriggerProps, 'elemBefore'>;

export function MoreProjectsFlyout(props: Props) {
	const cloudId = useCloudId();
	const currentURL = useGetCurrentUrl();

	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(MoreProjectsEntrypoint, {
		cloudId,
		currentURL,
	});

	const triggerRef = useEntryPointButtonTrigger(entryPointActions);

	return (
		<FlyoutMenuItem>
			<FlyoutMenuItemTrigger
				{...props}
				ref={triggerRef}
				elemBefore={<AlignTextLeftIcon label="" color="currentColor" />}
			/>
			<FlyoutMenuItemContent>
				<JiraEntryPointContainer
					entryPointReferenceSubject={entryPointReferenceSubject}
					id="sidebar-nav4-more-projects-flyout"
					packageName={PACKAGE_NAME}
					teamName={TEAM_NAME}
					errorFallback="flag"
					fallback={<SkeletonNavMenuItems />}
					runtimeProps={{}}
				/>
			</FlyoutMenuItemContent>
		</FlyoutMenuItem>
	);
}
